/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}


/**
 * @param {string} num
 * @returns {Boolean}
 */
export function validPhone(num) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return reg.test(num)
}

/**
 * @param {string} num
 * @returns {Boolean}
 */
export function validEncryptPhone(num) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{1}[*]{4}[0-9]{4}$/
  return reg.test(num)
}


/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLandline(str) {
  const reg = /^0\d{2,3}-[1-9]\d{6,7}$/
  return reg.test(str)
}


/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUserName(str) {
  const reg = /^\w{5,32}$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validName(str) {
  const reg = /^\S{2,8}$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validPassWord(str) {
  // const reg = /^[^\s]*$/
  const reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validPostcode(str) {
  const reg = /^[0-9]{6}$/
  return reg.test(str)
}


/**
 * @param {string} idCard
 * @returns {Boolean}
 */
export function validIDcard(idCard) {
  var initCityMap = function () {
    var cityMap = new Map();

    cityMap.set("11", "北京");
    cityMap.set("12", "天津");
    cityMap.set("13", "河北");
    cityMap.set("14", "山西");
    cityMap.set("15", "内蒙古");

    cityMap.set("21", "辽宁");
    cityMap.set("22", "吉林");
    cityMap.set("23", "黑龙江");

    cityMap.set("31", "上海");
    cityMap.set("32", "江苏");
    cityMap.set("33", "浙江");
    cityMap.set("34", "安徽");
    cityMap.set("35", "福建");
    cityMap.set("36", "江西");
    cityMap.set("37", "山东");

    cityMap.set("41", "河南");
    cityMap.set("42", "湖北");
    cityMap.set("43", "湖南");
    cityMap.set("44", "广东");
    cityMap.set("45", "广西");
    cityMap.set("46", "海南");

    cityMap.set("50", "重庆");
    cityMap.set("51", "四川");
    cityMap.set("52", "贵州");
    cityMap.set("53", "云南");
    cityMap.set("54", "西藏");

    cityMap.set("61", "陕西");
    cityMap.set("62", "甘肃");
    cityMap.set("63", "青海");
    cityMap.set("64", "宁夏");
    cityMap.set("65", "新疆");

    cityMap.set("81", "香港");
    cityMap.set("83", "台湾");
    cityMap.set("82", "澳门");
    // cityMap.set("91", "国外");
    return cityMap;
  };
  var prefix = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

  var suffix = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];

  if (/^(\d{6})(19|20)(\d{2})(1[0-2]|0[1-9])(0[1-9]|[1-2][0-9]|3[0-1])(\d{3})(\d|X|x)$/.test(idCard)) {
    var cityMap = initCityMap();

    if (!cityMap.get(idCard.substring(0, 2))) {
      return false;
    }
    var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和

    for (var i = 0; i < 17; i++) {

      idCardWiSum += Number(idCard.substring(i, i + 1)) * prefix[i];
    }
    var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
    var idCardLast = idCard.substring(17);//得到最后一位身份证号码

    //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
    if (idCardMod == 2) {
      if (idCardLast.toLowerCase() == "x") {
        return true;
      } else {
        return false;
      }
    } else {
      //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
      if (idCardLast == (String(suffix[idCardMod]))) {
        return true;
      } else {
        return false;
      }
    }
  }
  return false;
}
export function validIDcard2(id) {
  // 检查身份证号码长度
  if (id.length !== 18) {
    return false;
  }

  // 检查前17位是否全为数字
  if (!/^\d{17}$/.test(id.slice(0, 17))) {
    return false;
  }

  // 检查最后一位是否为数字或X/x
  if (!/^[0-9Xx]$/.test(id.slice(17, 18))) {
    return false;
  }

  // 计算校验码
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checkDigits = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  let sum = 0;
  for (let i = 0; i < weights.length; i++) {
    sum += parseInt(id[i], 10) * weights[i];
  }
  const mod = sum % 11;
  const expectedCheckDigit = checkDigits[mod];
  return expectedCheckDigit === id[17].toUpperCase(); // 比较时不区分大小写
}



